import axios from 'axios'
import {useAccountStore} from "@/stores/account.store.ts";
import router from "@/router/router.ts";
import {useDialogStore} from "@/stores/dialog.store.ts";
import {RouteEnum} from "@/router/RouteEnum.ts";

const isCypressRuntime = typeof window !== 'undefined' && 'Cypress' in window

const Axios = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    Accept: 'application/json'
  },
  params: import.meta.env.VITE_DEBUG_XDEBUG === 'true' && !isCypressRuntime
    ? {XDEBUG_SESSION: 'PHPSTORM'}
    : {},
})

Axios.interceptors.request.use((request) => {
  request.headers.Accept = 'application/json'
  if (useAccountStore().isLogged()) {
    request.headers.Authorization = 'Bearer ' + useAccountStore().token
  }

  return request
})

Axios.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if ('ERR_NETWORK' === error.code) {
      useDialogStore().error('Serveur injoignable', 'le serveur est actuellement injoignable, contacter la SI')
      return Promise.reject(error)
    } else if (!error.response) {
      return Promise.reject(error)
    } else {
      if (error.response.status === 401) {
        const account = useAccountStore()
        const currentRoute = router.currentRoute.value
        account.logout()
        if (currentRoute.name !== RouteEnum.Login && currentRoute.name !== RouteEnum.AuthCallback) {
          account.originRoute = currentRoute.fullPath
          await router.replace({name: RouteEnum.Login, query: {reason: 'api-session-rejected'}})
        }
      }
      return Promise.reject(error)
    }
  }
)

export default Axios
